import type { Category, CategoryBase, Group } from '@wix/add-panel-common';
import { assoc, F, filter, ifElse, includes, isNil, map, pipe, propSatisfies } from 'ramda';
import { hasCustomCategoryComponent } from '../../AddPanel/CategoryView/CustomCategory/helpers';
import { checkModes } from '../../AddPanel/utils/modes/modes';
import type { ConditionHelpers } from '../../AddPanel/UtilsProvider/UtilsProvider.types';
import { sortByIndex } from '../array';
import { filterEntitiesWithChildren } from './common';

export const canRenderCategoryView = (category: CategoryBase): boolean =>
  !category.isCustom || hasCustomCategoryComponent(category);

const addGroups =
  (allGroups: Group[]) =>
  (category: CategoryBase): Category => {
    const groupsForCategory = filter(
      propSatisfies(ifElse(isNil, F, includes(category.systemId)), 'categoryIds'),
      allGroups,
    );
    return assoc('groups', groupsForCategory, category);
  };

const canRenderCategoryForCurrentMode =
  (conditionHelpers: ConditionHelpers) =>
  (category: CategoryBase): boolean =>
    Array.isArray(category.modes) ? checkModes(category.modes, conditionHelpers) : false;

export const transformCategories = (categories: CategoryBase[], groups: Group[], conditionHelpers: ConditionHelpers) =>
  pipe<CategoryBase[], CategoryBase[], CategoryBase[], CategoryBase[], Category[], Category[]>(
    filter(canRenderCategoryForCurrentMode(conditionHelpers)),
    filter(canRenderCategoryView),
    sortByIndex,
    map(addGroups(groups)),
    filterEntitiesWithChildren('groups'),
  )(categories);
